/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaListApiResponse
 */
export interface MediaListApiResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof MediaListApiResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof MediaListApiResponse
     */
    message: string;
}

export function MediaListApiResponseFromJSON(json: any): MediaListApiResponse {
    return MediaListApiResponseFromJSONTyped(json, false);
}

export function MediaListApiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaListApiResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function MediaListApiResponseToJSON(value?: MediaListApiResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

